import { styled } from '../../configs/stitches.config';

export const BadgeStatus = styled('p', {
  font: '$captionRegular',
  marginLeft: '$spacingSm',
});

export const BalanceArea = styled('div', {
  alignItems: 'center',
  backgroundColor: '$backgroundSecondary',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingLeft: '$spacingMd',
  paddingRight: '$spacingMd',
  paddingTop: '$spacingLg',
  width: '100%',

  '@lg': {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: '$spacing5xl',
  },
});

export const BalanceAreaWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  '@lg': {
    maxWidth: '810px',
  },
});

export const BalanceData = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const BalanceDataArea = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '$spacingLg',
  marginTop: '$spacingLg',
  justifyContent: 'space-between',
  width: '100%',

  '@lg': {
    maxWidth: '810px',
  },
});

export const BalanceDataRow = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  '@lg': {
    flexDirection: 'row',
  },
});

export const BalanceSecondaryDataRow = styled(BalanceDataRow, {
  marginTop: '$spacingLg',
});

export const BalanceDataTitle = styled('h2', {
  font: '$titleBold',
  marginBottom: '$spacingMd',
  width: '100%',

  '@lg': {
    font: '$headingMdBold',
    marginBottom: '$spacingLg',
  },
});

export const BalanceDataValue = styled('div', {
  alignItems: 'center',
  display: 'flex',
  font: '$titleBold',

  '&:before': {
    content: '\u2022',
    marginRight: '$spacingSm',
    width: 'fit-content',
  },

  variants: {
    theme: {
      unpaid: { color: '$semanticsWarning' },
      paid: { color: '$semanticsPositive' },
    },
  },
});

export const BalanceDataWrapper = styled('div', {
  backgroundColor: '$backgroundPrimary',
  border: '1px solid $borderColorLight',
  borderRadius: '$borderRadiusLg',
  boxShadow: '$shadowBase',
  display: 'flex',
  flexDirection: 'column',
  padding: '$spacingXl',
  width: '100%',

  '@lg': {
    flexDirection: 'row',
    width: 'auto',
  },
});

export const BalanceInformationImage = styled('div', {
  display: 'none',
  height: '107px',
  width: '242px',

  '@lg': {
    display: 'block',
  },
});

export const BalanceInformationImageWrapper = styled('div', {
  marginLeft: 'auto',
});

export const BalanceDataAndModalWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const BalanceValue = styled('p', {
  color: '$textColorPrimary',
});

export const BalanceValueTitle = styled('h3', {
  font: '$labelRegular',

  '@lg': {
    font: '$bodyRegular',
  },
});

export const Disclaimer = styled('p', {
  font: '$captionRegular',
  margin: '$spacing4xl auto 0',
  padding: '0 $spacingMd',
  textAlign: 'center',

  '@lg': {
    padding: 0,
    maxWidth: '884px',
  },
});

export const LoadingWrapper = styled('div', {
  padding: '300px 0',
});

export const ModalButton = styled('button', {
  color: '$surfaceInteractionPrimary',
  marginRight: 'auto',
  marginTop: '$spacingMd',
  paddingLeft: '0',
  width: 'fit-content',
});

export const PaymentsArea = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  padding: '$spacing2xl $spacingMd',
  width: '100%',

  '@lg': {
    maxWidth: '810px',
    padding: '$spacing5xl $spacingMd',
  },
});

export const PaymentsAreaTitle = styled('h2', {
  font: '$titleBold',
  marginBottom: '$spacingLg',

  '@lg': {
    font: '$headingMdBold',
  },
});

export const PaymentsWarning = styled('div', {
  alignItems: 'flex-start',
  backgroundColor: '$backgroundWarning',
  borderRadius: '$borderRadiusMd',
  display: 'flex',
  font: '$bodyRegular',
  gap: '$spacingSm',
  marginBottom: '$spacingLg',
  padding: '$spacingMd',

  '@lg': {
    font: '$bodyRegular',
    padding: '$spacingLg',
  },
});

export const PaymentsWarningText = styled('p', {
  color: '$textColorPrimary',
  font: '$labelRegular',
  lineHeight: '1.5',
  margin: 0,

  '@lg': {
    font: '$bodyRegular',
  },
});

export const PaymentsWarningLink = styled('a', {
  alignItems: 'center',
  color: '$surfaceInteractionPrimary',
  display: 'inline-flex',
  gap: '$spacingXsm',
  textDecoration: 'underline',
  transition: 'opacity 0.2s',

  '&:hover': {
    opacity: 0.8,
  },

  svg: {
    height: '16px',
    width: '16px',
    fill: 'currentColor',
  },
});

export const PaymentBadge = styled('div', {
  alignItems: 'center',
  backgroundColor: '#A3E596',
  borderRadius: '1.8rem',
  display: 'flex',
  marginLeft: '$spacingSm',
  padding: '$spacingXsm $spacingSm',
  width: 'fit-content',
});

export const PaymentsDataArea = styled('div', {
  '@lg': {
    borderRadius: '$borderRadiusLg',
    boxShadow: '$shadowBase',
    padding: '$spacingXl',
  },
});

export const Payment = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '$spacingMd',
});

export const PaymentInfoWrapper = styled('div', {
  alignItems: 'center',
  display: 'flex',
});

export const PaymentTitle = styled('h3', {
  font: '$bodyBold',
  marginRight: '$spacingXsm',
});

export const PaymentValue = styled('p', {
  font: '$bodyBold',
  marginLeft: 'auto',
});

export const WelcomeDescription = styled('p', {
  font: '$bodyRegular',
  marginBottom: '$spacingLg',
  marginTop: '$spacingSm',

  '@lg': {
    marginBottom: '$spacingXl',
  },
});

export const WelcomeInformation = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const WelcomeTitle = styled('h1', {
  font: '$headingLgBold',

  '@lg': {
    font: '$headingXlBold',
  },
});

export const BalancePageShell = styled('div', {
  background: 'linear-gradient(180deg, #f7f8fc 0%, #f3f5fb 48%, #eef2f8 100%)',
  minHeight: '100%',
  padding: '$spacingXl $spacingMd $spacing4xl',

  '@lg': {
    padding: '$spacing4xl $spacingLg $spacing5xl',
  },
});

export const BalancePageContent = styled('div', {
  margin: '0 auto',
  maxWidth: '1180px',
  width: '100%',
});

export const HeaderSection = styled('section', {
  marginBottom: '$spacingLg',
});

export const HeaderDivider = styled('div', {
  backgroundColor: '#d8dee8',
  height: '1px',
  marginTop: '$spacingLg',
  width: '100%',
});

export const SummarySection = styled('section', {
  backgroundColor: 'rgba(247, 248, 252, 0.96)',
  marginBottom: '$spacingSm',
  paddingBottom: '$spacingSm',
  position: 'sticky',
  top: 0,
  zIndex: 1,
});

export const SummarySectionTitle = styled('h2', {
  color: '#42526b',
  fontSize: '1rem',
  fontWeight: 700,
  marginBottom: '$spacingMd',
});

export const SummaryCardsGrid = styled('div', {
  display: 'grid',
  gap: '$spacingMd',
  gridTemplateColumns: '1fr',

  '@md': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },

  '@lg': {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  },
});

export const SummaryCardNoteGrid = styled('div', {
  display: 'grid',
  gap: '$spacingMd',
  gridTemplateColumns: '1fr',
  marginTop: '$spacingSm',
});

export const SummaryCard = styled('div', {
  borderRadius: '10px',
  boxShadow: '0 8px 18px rgba(16, 24, 40, 0.12)',
  backgroundColor: '#ffffff',
  border: '2px solid transparent',
  minWidth: 0,
  minHeight: '86px',
  overflow: 'hidden',
  padding: '$spacingMd',

  variants: {
    tone: {
      unpaid: {
        borderColor: '#1f2937',
        color: '#111827',
      },
      paid: {
        borderColor: '#32b96f',
        color: '#168f53',
      },
      issued: {
        borderColor: '#3e8ef7',
        color: '#2563d9',
      },
      overdue: {
        borderColor: '#ff9f43',
        color: '#ef6c00',
      },
    },
  },
});

export const SummaryCardLabel = styled('p', {
  fontSize: '0.85rem',
  fontWeight: 700,
  lineHeight: 1.2,
  margin: 0,
  opacity: 0.9,
});

export const SummaryCardActionRow = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '$spacingSm',
});

export const SummaryCardActionButton = styled('button', {
  alignItems: 'center',
  background: 'transparent',
  border: 'none',
  color: '#55657d',
  cursor: 'pointer',
  display: 'inline-flex',
  flexShrink: 0,
  fontSize: '0.72rem',
  fontWeight: 600,
  gap: '4px',
  lineHeight: 1.2,
  padding: 0,
  textDecoration: 'underline',

  '&:hover': {
    color: '#42526b',
  },
});

export const SummaryCardValue = styled('p', {
  fontSize: 'clamp(1rem, 1.5vw, 1.65rem)',
  fontWeight: 700,
  letterSpacing: '-0.035em',
  lineHeight: 1.1,
  margin: '$spacingSm 0 0',
  minWidth: 0,
  whiteSpace: 'nowrap',
});

export const SummaryActionHelperText = styled('p', {
  color: '#6b7789',
  fontSize: '0.92rem',
  fontWeight: 600,
  lineHeight: 1.45,
  margin: 0,
  maxWidth: 'none',
  textAlign: 'left',
  width: '100%',
});

export const PageSection = styled('section', {
  marginBottom: '$spacing4xl',
});

export const PageSectionTitle = styled('h2', {
  color: '#364152',
  fontSize: '1.35rem',
  fontWeight: 700,
  marginBottom: '$spacingLg',
});

export const CompactWarningCard = styled('div', {
  alignItems: 'flex-start',
  backgroundColor: '#fff4dd',
  border: '1px solid #f2d7a1',
  borderRadius: '10px',
  boxShadow: '0 6px 16px rgba(15, 23, 42, 0.06)',
  display: 'flex',
  gap: '$spacingMd',
  marginBottom: '$spacing2xl',
  padding: '$spacingMd $spacingLg',
});

export const CompactWarningIcon = styled('div', {
  alignItems: 'center',
  backgroundColor: '#f59e0b',
  borderRadius: '999px',
  color: '#fff',
  display: 'flex',
  flexShrink: 0,
  fontSize: '1.2rem',
  fontWeight: 700,
  height: '28px',
  justifyContent: 'center',
  width: '28px',
});

export const CompactWarningTextBlock = styled('div', {
  color: '#66512f',
  lineHeight: 1.5,
});

export const CompactWarningTitle = styled('span', {
  fontSize: '0.9rem',
  fontWeight: 700,
  marginRight: '$spacingXsm',
});

export const CompactWarningDescription = styled('span', {
  fontSize: '0.85rem',
  lineHeight: 1.5,
});

export const PaymentsEmptyState = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '$spacingMd',
  margin: '$spacing4xl 0',
  textAlign: 'center',
});

export const PaymentsEmptyText = styled('p', {
  color: '#3d4b63',
  fontSize: '1.2rem',
  fontWeight: 700,
  margin: 0,
});

export const PaymentsListCard = styled('div', {
  backgroundColor: '#fff',
  border: '1px solid #dbe2ee',
  borderRadius: '12px',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
  overflow: 'hidden',
});

export const PaymentsList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const PaymentsListItem = styled('div', {
  alignItems: 'center',
  borderTop: '1px solid #edf1f7',
  display: 'flex',
  gap: '$spacingSm',
  justifyContent: 'space-between',
  padding: '$spacingMd $spacingLg',

  '&:first-child': {
    borderTop: 'none',
  },
});

export const PaymentsListMonth = styled('span', {
  color: '#41516b',
  fontSize: '0.95rem',
  fontWeight: 600,
});

export const PaymentsListAmount = styled('span', {
  backgroundColor: '#eef9f2',
  borderRadius: '999px',
  color: '#1f9d57',
  display: 'inline-block',
  fontSize: '0.95rem',
  fontWeight: 700,
  minWidth: '108px',
  padding: '6px 10px',
  textAlign: 'right',
});

export const BottomDivider = styled('div', {
  backgroundColor: '#d8dee8',
  height: '1px',
  margin: '$spacingLg 0 $spacing2xl',
  width: '100%',
});

export const BillingGrid = styled('section', {
  display: 'grid',
  gap: '$spacingLg',
  gridTemplateColumns: '1fr',
  marginBottom: '$spacing4xl',
});

export const BillingTabs = styled('div', {
  alignItems: 'center',
  display: 'flex',
  gap: '$spacingSm',
  overflowX: 'auto',
  paddingBottom: '$spacingXsm',
});

export const BillingTabButton = styled('button', {
  backgroundColor: '#ffffff',
  border: '1px solid var(--tab-tone-border)',
  borderRadius: '999px',
  color: 'var(--tab-tone-color)',
  cursor: 'pointer',
  fontSize: '0.84rem',
  fontWeight: 700,
  lineHeight: 1.2,
  opacity: 0.8,
  padding: '$spacingSm $spacingMd',
  transition: 'all 0.2s ease',
  whiteSpace: 'nowrap',

  '&:hover': {
    opacity: 1,
  },

  "&[aria-selected='true']": {
    backgroundColor: '#ffffff',
    borderColor: 'var(--tab-tone-border)',
    color: 'var(--tab-tone-color)',
    boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)',
    opacity: 1,
  },

  variants: {
    tone: {
      unpaid: {
        '--tab-tone-border': '#1f2937',
        '--tab-tone-color': '#111827',
      },
      paid: {
        '--tab-tone-border': '#32b96f',
        '--tab-tone-color': '#168f53',
      },
      issued: {
        '--tab-tone-border': '#3e8ef7',
        '--tab-tone-color': '#2563d9',
      },
      overdue: {
        '--tab-tone-border': '#ff9f43',
        '--tab-tone-color': '#ef6c00',
      },
    },
  },

  defaultVariants: {
    tone: 'issued',
  },
});

export const BillingPanel = styled('div', {
  backgroundColor: '#fff',
  border: '1px solid #dbe2ee',
  borderRadius: '12px',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
  overflow: 'hidden',
});

export const BillingPanelHeader = styled('div', {
  borderBottom: '1px solid #edf1f7',
  padding: '$spacingMd $spacingLg',
});

export const BillingPanelTitle = styled('h3', {
  color: '#364152',
  fontSize: '1.1rem',
  fontWeight: 700,
  margin: 0,
});

export const BillingPanelBody = styled('div', {
  padding: '$spacingSm $spacingLg $spacingMd',
});

export const BillingPanelMeta = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$spacingXsm',
  marginBottom: '$spacingSm',
});

export const BillingPanelSubtitle = styled('p', {
  color: '#5e6b7d',
  fontSize: '0.84rem',
  lineHeight: 1.5,
  margin: 0,
});

export const BillingPanelHint = styled('p', {
  alignItems: 'center',
  backgroundColor: '#eef2f8',
  border: '1px solid #d3dbe8',
  borderRadius: '999px',
  color: '#66758d',
  display: 'inline-flex',
  fontSize: '0.60rem',
  fontWeight: 700,
  justifySelf: 'start',
  lineHeight: 1.1,
  margin: 0,
  padding: '5px 5px',
  whiteSpace: 'nowrap',
  width: 'fit-content',
});

export const IssuedListHeader = styled('div', {
  alignItems: 'center',
  display: 'flex',
  paddingBottom: '$spacingSm',
});

export const IssuedList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$spacingSm',
});

export const IssuedListItem = styled('div', {
  alignItems: 'center',
  borderBottom: '1px solid #edf1f7',
  color: '#42526b',
  display: 'grid',
  gap: '$spacingSm',
  gridTemplateColumns: '1fr auto',
  lineHeight: 1.4,
  paddingBottom: '$spacingSm',

  '&:last-child': {
    borderBottom: 'none',
    paddingBottom: 0,
  },
});

export const IssuedListText = styled('span', {
  display: 'inline-flex',
  flexDirection: 'column',
  gap: '2px',
});

export const IssuedListInlineText = styled('span', {
  alignItems: 'center',
  columnGap: '$spacingMd',
  display: 'inline-flex',
  flexWrap: 'wrap',
  rowGap: '$spacingXsm',
});

export const IssuedListDueIn = styled('span', {
  color: '#6b7789',
  fontSize: '0.72rem',
  fontWeight: 600,

  variants: {
    highlight: {
      true: {
        backgroundColor: '#eef2f8',
        border: '1px solid #d3dbe8',
        borderRadius: '999px',
        color: '#66758d',
        display: 'inline-flex',
        fontWeight: 700,
        padding: '2px 8px',
        width: 'fit-content',
      },
    },
  },
});

export const IssuedListDate = styled('span', {
  color: '#42526b',
  fontSize: '0.95rem',
  fontWeight: 600,
});

export const IssuedListValue = styled('span', {
  borderRadius: '999px',
  fontSize: '0.92rem',
  fontWeight: 700,
  marginLeft: '$spacingMd',
  minWidth: '108px',
  padding: '6px 10px',
  textAlign: 'right',

  variants: {
    tone: {
      issued: {
        backgroundColor: '#eef4ff',
        color: '#2563d9',
      },
      paid: {
        backgroundColor: '#eef9f2',
        color: '#1f9d57',
      },
    },
  },

  defaultVariants: {
    tone: 'issued',
  },
});

export const OverdueList = styled('div', {
  display: 'grid',
  gap: '$spacingMd',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  padding: '$spacingMd',
});

export const OverdueStatementCard = styled('div', {
  backgroundColor: '#fff',
  border: '1px solid #dbe2ee',
  borderRadius: '10px',
  boxShadow: '0 6px 18px rgba(15, 23, 42, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  overflow: 'hidden',
});

export const OverdueStatementHeader = styled('div', {
  backgroundColor: '#fafbfd',
  borderBottom: '1px solid #edf1f7',
  padding: '$spacingMd',
});

export const OverdueStatementMeta = styled('p', {
  color: '#506176',
  fontSize: '0.85rem',
  margin: 0,

  '& + &': {
    marginTop: '$spacingSm',
  },

  strong: {
    color: '#2d3c50',
  },
});

export const OverdueStatementAmount = styled('span', {
  backgroundColor: '#fff1e7',
  borderRadius: '999px',
  color: '#ef6c00',
  display: 'inline-block',
  fontWeight: 700,
  padding: '4px 10px',
});

export const OverdueStatementBreakdown = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$spacingSm',
  padding: '$spacingMd',
});

export const OverdueStatementRow = styled('div', {
  alignItems: 'center',
  display: 'grid',
  gap: '$spacingSm',
  gridTemplateColumns: '1fr auto',
});

export const OverdueStatementLabel = styled('span', {
  color: '#4f5f76',
  fontSize: '0.84rem',
  fontWeight: 600,
});

export const OverdueStatementValue = styled('span', {
  color: '#2d3c50',
  fontSize: '0.86rem',
  fontWeight: 700,
  minWidth: 0,
  textAlign: 'right',
});

export const PanelEmptyText = styled('p', {
  color: '#5d6c84',
  fontSize: '0.95rem',
  margin: 0,
  textAlign: 'center',
});
